import { createSlice } from '@reduxjs/toolkit';
import { fetcherPost, fetcherGet, fetcherPut  } from "../utils/fetcher";
import { setLoader } from './commonSlice';
import { APIS, isEmpty } from '../utils/constants';
// import { checkNextPage } from '../utils/logger';

const initialState = {
    addChecklistTask: null,
    defaultChecklist: [],
    allCheckList: [],
    addPremadeChecklist: null,
    premadeChecklists: []
}

const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
        setAddCheckListTask: (state, action) => {
            state.addChecklistTask = action.payload
        },
        setDefaultChecklist: (state, action) => {
            state.defaultChecklist = action.payload
        },
        setAllChecklist: (state, action) => {
            state.allCheckList = action.payload
        },
        setAddPremadeCheckListTask: (state, action) => {
            state.addPremadeChecklist = action.payload
        },
        setAllPremadeChecklists: (state, action) => {
            state.premadeChecklists = action.payload
        },
    },
});


export function addChecklistTaskData(payload, userId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost( userId ? `${APIS.POST_ADD_CHECKLIST_TASK}?user_id=${userId}`: `${APIS.POST_ADD_CHECKLIST_TASK}`, payload)
            .then(() => {
                dispatch(setAddCheckListTask(true));
                dispatch(userId ? getAllChecklist(userId): getAllChecklist());
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getDefaultChecklist(limit = 50, page = 1) {

    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS.GET_DEFAULT_CHECKLIST}?limit=${limit}&page=${page}`)
            .then((response) => {
                dispatch(setDefaultChecklist(!isEmpty(response?.data?.result) ? response?.data?.result : []));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getAllChecklist(userId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(userId ? `${APIS.GET_ALL_CHECKLIST}?user_id=${userId}` : `${APIS.GET_ALL_CHECKLIST}`)
            .then((response) => {
                dispatch(setAllChecklist(!isEmpty(response?.data) ? response?.data : []));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function updateChecklistTask(payload, userId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        // const { user_id, ...rest } = payload;
        fetcherPut(userId ? `${APIS.PUT_UPDATE_CHECKLIST}?user_id=${userId}` : `${APIS.PUT_UPDATE_CHECKLIST}`, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(userId ?getAllChecklist(userId):getAllChecklist());
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function addPremadeChecklist(payload, userId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(userId ? `${APIS.POST_ADD_PREMADE_CHECKLIST_TASK}?user_id=${userId}` : `${APIS.POST_ADD_PREMADE_CHECKLIST_TASK}` , payload)
            .then(() => {
                dispatch(setAddPremadeCheckListTask(true));
                dispatch(userId? getAllChecklist(userId) : getAllChecklist());
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getAllPremadeChecklists() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS.GET_PREMADE_CHECKLIST}`)
            .then((response) => {
                dispatch(setAllPremadeChecklists(!isEmpty(response?.data) ? response?.data : []));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export const { setAddCheckListTask, setDefaultChecklist, setAllChecklist, setAddPremadeCheckListTask, setAllPremadeChecklists } = taskSlice.actions;

export default taskSlice.reducer;